import Vue from 'vue'
import VueRouter from 'vue-router'

import FailPaymant from '../components/FailPaymant.vue'
import SuccessPaymant from '../components/SuccessPaymant.vue'
import OrderVpn from '../components/OrderVpn.vue'
import OrderVpnVip from '../components/OrderVpnVip.vue'
import PaymentMethods from '../components/PaymentMethods.vue'
import OrderVpnCode from '../components/OrderVpnCode.vue'
import OrderVpnResult from '../components/OrderVpnResult.vue'
import AppBase from '../components/AppBase.vue'
import AppBaseR from '../components/AppBaseR.vue'
import DataLoader from '../components/DataLoader.vue'
import ContactUs from '../components/ContactUs.vue'
import HelpUser from '../components/HelpUser.vue'
import Rules from '../components/Rules.vue'
import AboutService from '../components/AboutService.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/rules',
    component: AppBaseR,
    children: [
      {
        path: '/',
        name: 'Rules',
        component: Rules
      }]
  },
  {
    path: '/payment-methods',
    name: 'PaymentMethods',
    component: PaymentMethods
  },
  {
    path: '/about-service',
    component: AppBaseR,
    children: [
      {
        path: '/',
        name: 'AboutService',
        component: AboutService
      }]
  },
  {
    path: '/',
    component: AppBase,
    children: [
      {
        path: '/buy-code',
        name: 'OrderVpn',
        component: OrderVpn
      },
      {
        path: '/buy-vip',
        name: 'OrderVpnVip',
        component: OrderVpnVip
      },
      {
        path: '/',
        name: 'OrderVpnCode',
        component: OrderVpnCode
      }, {
        path: '/code-result',
        name: 'OrderVpnResult',
        component: OrderVpnResult
      }, {
        path: '/success-paymant/:code',
        name: 'SuccessPaymant',
        component: SuccessPaymant
      }, {
        path: '/success-paymant',
        name: 'SuccessPaymant',
        component: SuccessPaymant
      }, {
        path: '/fail-paymant',
        name: 'FailPaymant',
        component: FailPaymant
      }, {
        path: '/loader',
        name: 'DataLoader',
        component: DataLoader
      },
      {
        path: '/help',
        name: 'HelpUser',
        component: HelpUser
      }, {
        path: '/contactUs',
        name: 'ContactUs',
        component: ContactUs
      }]
  }
]
const router = new VueRouter({
  routes
})

export default router
